import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchPublicMatchWatch } from '../../../services/matchService';

const youtubeEmbedUrl = (url = '') => {
  const text = String(url || '').trim();
  if (!text) return '';
  const fromWatch = text.match(/[?&]v=([^&]+)/i)?.[1] || '';
  const fromShort = text.match(/youtu\.be\/([^?&/]+)/i)?.[1] || '';
  const fromEmbed = text.match(/embed\/([^?&/]+)/i)?.[1] || '';
  const videoId = fromWatch || fromShort || fromEmbed;
  return videoId ? `https://www.youtube.com/embed/${videoId}?autoplay=1` : text;
};

const PublicMatchWatchPage = () => {
  const { matchId } = useParams();
  const [watchData, setWatchData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadWatchData = async () => {
      if (!matchId) return;
      try {
        const payload = await fetchPublicMatchWatch({ matchId });
        setWatchData(payload);
        setError('');
      } catch (loadError) {
        setError(loadError?.message || 'Unable to load watch page.');
      }
    };
    loadWatchData();
  }, [matchId]);

  const embedUrl = useMemo(() => youtubeEmbedUrl(watchData?.youtubePlaybackUrl || watchData?.playbackUrl), [watchData]);

  return (
    <main className="container py-4">
      <div className="d-flex align-items-center gap-2 mb-3">
        <h1 className="h4 mb-0">{watchData?.matchTitle || 'Live match'}</h1>
        <span className={`badge ${watchData?.isLive ? 'bg-danger' : 'bg-secondary'}`}>{watchData?.isLive ? 'LIVE' : 'OFFLINE'}</span>
      </div>
      <p className="text-muted mb-4">{[watchData?.team1, watchData?.team2].filter(Boolean).join(' vs ')}</p>

      {error ? <div className="alert alert-danger">{error}</div> : null}

      {embedUrl ? (
        <div className="ratio ratio-16x9 rounded overflow-hidden shadow-sm border">
          <iframe
            src={embedUrl}
            title="CrickArena live stream"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      ) : (
        <div className="alert alert-warning">Live stream URL is not configured for this match yet.</div>
      )}
    </main>
  );
};

export default PublicMatchWatchPage;
